import { AxiosResponse, isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { DocumentsHistoryListInfo } from '@/pages/DocumentsHistory/types';

type GetDocumentsHistoryResponse = {
  value: DocumentsHistoryListInfo[];
};

type QueryType = {
  fechaDesde: Date | null;
  fechaHasta: Date | null;
};

type GetDocumentPdf = {
  guid: string;
};

export const getDocumentsHistory = async (
  query: QueryType
): Promise<DocumentsHistoryListInfo[]> => {
  try {
    const res = await apiClient.post<GetDocumentsHistoryResponse>(
      Endpoints.DocumentsHistory,
      query
    );
    return res.data.value || [];
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};

export const getDocumentPDF = async (
  query: GetDocumentPdf
): Promise<AxiosResponse> => {
  try {
    const res = await apiClient.post<AxiosResponse>(
      Endpoints.DownloadDPDFocument,
      query
    );
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error();
    }
    throw error;
  }
};
